(function() {
    angular
        .module("app")
        .controller("AppController", AppController)

    AppController.$inject = [
        "$rootScope",
        "$scope",
        "$filter",
        "$stateParams",
        "$state",
        "$location",
        "feedbackService",
        "userMessagingService",
        "fmPushService"
    ]

    function AppController(
        $rootScope,
        $scope,
        $filter,
        $stateParams,
        $state,
        $location,
        feedbackService,
        userMessagingService,
        fmPushService
    ){
        "use strict"

        /**
            $rootScope NTCIP
         **/
        var _signType = {

            // # NTCIP 1203v03-04_part_1_dms2011.pdf -> Section 5.2.2

            "Other":             1,
            "BOS":               2,
            "CMS":               3,
            "VMSChar":           4,
            "VMSLine":           5,
            "VMSFull":           6,
            "PortableOther":   129,
            "PortableBOS":     130,
            "PortableCMS":     131,
            "PortableVMSChar": 132,
            "PortableVMSLine": 133,
            "PortableVMSFull": 134,
        }

        // let deviceIsMessageBoard = function(obj) {
        //     if (obj !== undefined) {
        //         if (obj === "MessageBoard")         { return true }
        //         if (obj.hasOwnProperty("category")) { return deviceIsMessageBoard(obj.category) }
        //         if (obj.hasOwnProperty("device"))   { return deviceIsMessageBoard(obj.device) }
        //         if (obj.hasOwnProperty("type"))     { return deviceIsMessageBoard(obj.type)}
        //     }
        //     return false
        // }

        //  var deviceIsTracker = function(obj) {
        //     if (obj !== undefined) {
        //         if (obj === "Tracker")              { return true }
        //         if (obj.hasOwnProperty("category")) { return deviceIsTracker(obj.category) }
        //         if (obj.hasOwnProperty("device"))   { return deviceIsTracker(obj.device) }
        //     }
        //     return false
        // }

        let deviceIsWanco = function(obj) {
            if (obj !== undefined) {
                if (obj === "Wanco")                    { return true }
                if (obj.hasOwnProperty("manufacturer")) { return deviceIsWanco(obj.manufacturer) }
                if (obj.hasOwnProperty("device"))       { return deviceIsWanco(obj.device) }
            }
            return false
        }

        $rootScope.processDevice = function(device) {
            if (device.hasOwnProperty("device")) {

                $rootScope.processRefreshed(device)
                $rootScope.processGPS(device)

                if (!device.hasOwnProperty("meta")) { device.meta = {} }
                // device.meta.isMessageBoard                  = deviceIsMessageBoard(device)
                device.meta.isMessageBoard                  = device.device.hasOwnProperty("type") && device.device.type === "MessageBoard"
                // device.meta.isMessageBoardSpeedLimitTrailer = device.hasOwnProperty("speed_limit_display") || (device.hasOwnProperty("device") && device.device.hasOwnProperty("model_number") && typeof device.device.model_number === "string" && device.device.model_number.startsWith("WVSL"))
                device.meta.isSpeedLimitTrailer             = device.hasOwnProperty("speed_limit_display")
                device.meta.isWvsl2                         = device.hasOwnProperty("wvsl2")
                device.meta.isMessageBoardSpeedLimitTrailer = device.meta.isSpeedLimitTrailer || device.meta.isWvsl2
                device.meta.isTracker                       = !device.meta.isMessageBoard
                device.meta.isTrackerCalAmp                 = device.meta.isTracker && device.hasOwnProperty("is_calamp") && device.is_calamp
                device.meta.isTrackerSunTech                = device.meta.isTracker && !device.meta.isTrackerCalAmp
                device.meta.isTrackerGeneric                = device.hasOwnProperty("type") && device.type === "Tracker"
                device.meta.isTrackerGenericDeprecated      = device.hasOwnProperty("type") && device.type === "Tracker (Old Style)"
                device.meta.isTrackerArrowBoard             = device.hasOwnProperty("type") && device.type === "Arrow Board"
                device.meta.isTrackerRCUArrowBoard          = device.meta.isTrackerArrowBoard && device.device.hasOwnProperty("model_number") && device.device.model_number.indexOf("RCU") >= 0
                device.meta.isTrackerTrucksEnter            = device.hasOwnProperty("type") && device.type === "Trucks Enter"
                device.meta.isTrackerBeaconTrailer          = device.hasOwnProperty("type") && device.type === "Beacon Trailer"
                device.meta.isTrackerSolarLightTower        = device.hasOwnProperty("type") && device.type === "Solar Light Tower"
                device.meta.isTrackerSpeedTrailer           = device.hasOwnProperty("type") && device.type === "Speed Trailer"
                device.meta.isTrackerQwsSensor              = device.hasOwnProperty("type") && device.type === "QWS Sensor"
                device.meta.isTrackerAFADGate               = device.hasOwnProperty("type") && device.type === "Flagger"
                device.meta.isTrackerMarker                 = device.hasOwnProperty("type") && device.type === "Marker"
                device.meta.hasLiveTracking                 = !device.meta.isTrackerSunTech && (device.meta.isTrackerGeneric || device.meta.isTrackerArrowBoard || device.meta.isTrackerTrucksEnter || device.meta.isTrackerAFADGate || device.meta.isTrackerMarker)
                device.meta.isAlwaysOn                      = device.meta.isMessageBoard || device.meta.isTrackerArrowBoard || device.meta.isTrackerAFADGate || device.meta.isTrackerTrucksEnter || device.meta.isTrackerQwsSensor || device.meta.isTrackerSunTech
                device.meta.isWancoDevice                   = deviceIsWanco(device)
                device.meta.isRequesting                    = false
                device.meta.inProcess                       = device.hasOwnProperty("in_process") && device.in_process === true
                device.meta.inWz                            = device.hasOwnProperty("wz")
                device.meta.isWzOutput                      = device.hasOwnProperty("wz") && device.wz.output
                device.meta.isCharacterBoard                = device.meta.isMessageBoard && device.hasOwnProperty("sign_type") && device.sign_type === 132
                device.meta.isMatrixBoard                   = device.meta.isMessageBoard && device.hasOwnProperty("sign_type") && device.sign_type === 134
                device.meta.supportsGraphicMessages         = device.meta.isWancoDevice && device.meta.isMatrixBoard
                device.meta.supportsMultipleColors          = device.meta.isWancoDevice && device.meta.isMessageBoard && device.hasOwnProperty("num_colors") && device.num_colors > 1
                device.meta.useV2Messaging                  = device.meta.isWancoDevice && device.hasOwnProperty("fonts") && device.fonts.length > 0
            }
        }

        const temperatureCtoF = (temperature) => {
            if (typeof temperature !== "number" || isNaN(temperature) || !isFinite(temperature)) { return $rootScope.temperatureCtoF(0) }
            // °F = (°C × 9/5) + 32
            return Math.round((temperature * (9 / 5)) + 32)
        }

        const temperatureFtoC = (temperature) => {
            if (typeof temperature !== "number" || isNaN(temperature) || !isFinite(temperature)) { return $rootScope.temperatureFtoC(0) }
            // °C = (°F − 32) x 5/9
            return Math.round((temperature - 32) * (5 / 9))
        }

        $rootScope.displayTemperatureFromF = (temperature) => {
            if (temperature === "Unknown" || typeof temperature !== "number" || isNaN(temperature) || !isFinite(temperature)) { return "Unknown" }
            return Math.round(temperature) + " °F (" + temperatureFtoC(temperature) + " °C)"
        }

        $rootScope.displayTemperatureFromC = (temperature) => {
            if (temperature === "Unknown" || typeof temperature !== "number" || isNaN(temperature) || !isFinite(temperature)) { return "Unknown" }
            return temperatureCtoF(temperature) + " °F (" + Math.round(temperature) + " °C)"
        }

        $rootScope.NTCIP = {
            "SignType": _signType
        }

        $rootScope.generateMessageID = function(type, number) {
            if (number <= 9) {
                return "" + type + "00" + number
            } else if (number <= 99) {
                return "" + type + "0" + number
            } else {
                return "" + type + number
            }
        }

        $rootScope.presentDateTime = (date, format, timezone_iana) => {

            if (timezone_iana !== null && timezone_iana !== undefined && timezone_iana !== "Etc/UTC") {

                const tzDate = moment(date).tz(timezone_iana)

                if (format === "NumericShortDate") {
                    return tzDate.format("yyyy-MM-DD")
                }

                if (format === "NumericLongDate") {
                    return tzDate.format("yyyy-MM-DD @ h:mm:ss A z")
                }

                // if (format === "NumericShortDateAlt") {
                //     return tzDate.format("MM/DD/yyyy")
                // }

                // if (format === "NumericLongDateAlt") {
                //     return tzDate.format("MM/DD/yyyy @ h:mm:ss A z")
                // }

                if (format === "TextShortDate") {
                    return tzDate.format("MMM Do, yyyy")
                }

                if (format === "TextMediumDate") {
                    return tzDate.format("MMM Do @ h:mm A z")
                }

                if (format === "TextLongDate") {
                    return tzDate.format("MMM Do, yyyy @ h:mm:ss A z")
                }

                if (format === "Time") {
                    return tzDate.format("h:mm:ss A z")
                }

                if (format === "TimeNoSeconds") {
                    return tzDate.format("h:mm A z")
                }

                if (format === "TimeHour") {
                    return tzDate.format("HH")
                }

                if (format === "TimeHourAMPM") {
                    return tzDate.format("h")
                }

                if (format === "TimeMinute") {
                    return tzDate.format("mm")
                }

                if (format === "TimeSecond") {
                    return tzDate.format("ss")
                }

                return $rootScope.presentDateTime(date, "NumericLongDate", timezone_iana)

            }

            if (format === "NumericShortDate") {
                return $filter("date")(date, "yyyy-MM-dd")
            }

            if (format === "NumericLongDate") {
                return $filter("date")(date, "yyyy-MM-dd @ h:mm:ss a")
            }

            // if (format === "NumericShortDateAlt") {
            //     return $filter("date")(date, "MM/dd/yyyy")
            // }

            // if (format === "NumericLongDateAlt") {
            //     return $filter("date")(date, "MM/dd/yyyy @ h:mm:ss a")
            // }

            if (format === "TextShortDate") {
                return $filter("date")(date)
            }

            if (format === "TextMediumDate") {
                return $filter("date")(date, "MMM d @ h:mm a")
            }

            if (format === "TextLongDate") {
                return $filter("date")(date, "MMM d, yyyy @ h:mm:ss a")
            }

            if (format === "Time") {
                return $filter("date")(date, "h:mm:ss a")
            }

            if (format === "TimeNoSeconds") {
                return $filter("date")(date, "h:mm a")
            }

            if (format === "TimeHour") {
                return $filter("date")(date, "HH")
            }

            if (format === "TimeHourAMPM") {
                return $filter("date")(date, "h")
            }

            if (format === "TimeMinute") {
                return $filter("date")(date, "mm")
            }

            if (format === "TimeSecond") {
                return $filter("date")(date, "ss")
            }

            return $rootScope.presentDateTime(date, "NumericLongDate", timezone_iana)

        }

        $rootScope.adjustedDate = (date, timezone_iana) => {

            if (timezone_iana !== null && timezone_iana !== undefined && timezone_iana !== "Etc/UTC") {

                return moment(date).tz(timezone_iana).toDate()

            } else {

                return moment(date).toDate()

            }
        }


        $rootScope.processRefreshed = (device) => {

            if (device.hasOwnProperty("device")) {

                if (!device.initialized || !device.hasOwnProperty("telemetry")) {
                    device.device.refreshedAtShort = "Never"
                    device.device.refreshedAtLong  = "Never"
                } else {
                    device.device.refreshedAtShort = $rootScope.presentDateTime(device.telemetry.created_at, "TextShortDate", device.device.timezone_iana)
                    device.device.refreshedAtLong  = $rootScope.presentDateTime(device.telemetry.created_at, "TextLongDate",  device.device.timezone_iana)
                    device.device.refreshedAtTime  = $rootScope.presentDateTime(device.telemetry.created_at, "Time",      device.device.timezone_iana)
                }
            }
        }

        $rootScope.processGPS = function(value) {

            if (Object.prototype.toString.call(value) === "[object Object]") {

                let initialized = true

                var gps = {
                    isValid: false,
                    notZero: true,
                    lat:     90,
                    lon:     180
                }

                if (value.hasOwnProperty("gps")) {

                    angular.forEach(value.gps, function(val, key) {
                        gps[key] = val
                    })
                    value.gps = gps

                } else if (value.hasOwnProperty("telemetry")) {

                    if (value.telemetry.hasOwnProperty("lat")) {
                        gps.lat = value.telemetry.lat
                        value.telemetry.lat = undefined
                    }
                    if (value.telemetry.hasOwnProperty("lon")) {
                        gps.lon = value.telemetry.lon
                        value.telemetry.lon = undefined
                    }
                    if (value.telemetry.hasOwnProperty("gps")) {
                        angular.forEach(value.telemetry.gps, function(val, key) {
                            gps[key] = val
                        })
                    }
                    value.telemetry.gps = gps

                } else {

                    if (value.hasOwnProperty("lat")) {
                        gps.lat = value.lat
                        value.lat = undefined
                    }
                    if (value.hasOwnProperty("lon")) {
                        gps.lon = value.lon
                        value.lon = undefined
                    }
                    value.gps = gps
                }

                if (value.hasOwnProperty("initialized") && value.initialized === false) {
                    initialized = false
                }

                gps.isValid = initialized && (gps.lat < 90 && gps.lat > -90 && gps.lon < 180 && gps.lon > -180)
                gps.notZero = (gps.lat != 0 || gps.lon != 0) // Rails presenters return the DECIMAL(0,7) columns of gps.lat and gps.lon as strings, which evaulates "0.0" === 0 as false, using != instead of !==

            }

            return value

        }

        $rootScope.getBearingName = (degrees) => {

            if (degrees >= 0 && degrees <= 359) {

                switch (true) {

                    case degrees < 11.25 || degrees >= 348.75:
                        return "North"
                    case degrees < 33.75:
                        return "North-northeast"
                    case degrees < 56.25:
                        return "Northeast"
                    case degrees < 78.75:
                        return "East-northeast"
                    case degrees < 101.25:
                        return "East"
                    case degrees < 123.75:
                        return "East-southeast"
                    case degrees < 146.25:
                        return "Southeast"
                    case degrees < 168.75:
                        return "South-southeast"
                    case degrees < 191.25:
                        return "South"
                    case degrees < 213.75:
                        return "South-southwest"
                    case degrees < 236.25:
                        return "Southwest"
                    case degrees < 258.75:
                        return "West-southwest"
                    case degrees < 281.25:
                        return "West"
                    case degrees < 303.75:
                        return "West-northwest"
                    case degrees < 326.25:
                        return "Northwest"
                    case degrees < 348.75:
                        return "North-northwest"
                }
            }

            return "Unknown"

        }

        /**
            $rootScope variables
         **/
        $rootScope.pushedData = {
            device:   {},
            deviceID: 0,
            reload:   false
        }

        $rootScope.pushedWzData = {
            wz: {}
        }

        $rootScope.isWancoDevice = false
        $rootScope.customers = []

        /**
            $scope variables
         **/
        $scope.$state = $state
        $scope.customerFeedbackFormData = {}
        $scope.feedbackFormOpen = false

        /**
            Check if is page
            @param viewLocation
            @returns {boolean}
         **/
        $scope.isPage = function(viewLocation) {
            return viewLocation === $location.path()
        }

        /**
            Dismiss alerts
         **/
        $scope.alertSuccessDismiss = function() {
            userMessagingService.dismissSuccess()
        }
        $scope.alertFailureDismiss = function() {
            userMessagingService.dismissFailure()
        }
        $scope.alertInfoDismiss = function() {
            userMessagingService.dismissInfo()
        }

        /**
            Toggle feedback form
         **/
        $scope.toggleFeedbackForm = function() {
            $scope.feedbackFormOpen = !$scope.feedbackFormOpen
        }

        /**
            Send customer feedback
         **/
        $scope.sendFeedback = function() {
            $scope.customerFeedbackFormSubmitted = true
            if ($scope.customerFeedbackForm.$valid) {
                $scope.customerFeedbackFormSubmitted = false

                feedbackService.submitFeedback(
                    angular.fromJson($scope.customerFeedbackFormData),
                    function() {
                        //Success
                        $scope.feedbackFormOpen = false
                        $scope.customerFeedbackFormData = {}
                        userMessagingService.success("Thank you for submitting your feedback.")
                    },
                    function() {
                        //Failure
                        userMessagingService.error("Feedback Submit Failure")
                    }
                )
            }
        }

        /**
            FM Push Service init (Websocket | Server Sent Events | PubNub)
        **/

        $scope.$watch("$root.is_authenticated", function(isAuthenticated) {

            if (!isAuthenticated) {

                fmPushService.disconnect()

            } else if (isAuthenticated && $rootScope.user && $rootScope.user.customer_id) {

                fmPushService.initialize($rootScope.user.customer_id)

            }

        })

    }
})()
